import { routeList, vehicles } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository({ timeout: 120000 });

export default {
  async getRoute(workgroupInstanceIds, lightMode = false) {
    const r = await client.get(routeList.route, { workgroupInstanceIds, lightMode });
    return r;
  },
  async getRoutes(id, reservationDay = null) {
    const r = await client.get(routeList.routes.replace(':instanceId', id), { reservationDay });
    return r;
  },
  async getTickets(id) {
    const r = await client.get(routeList.tickets.replace(':routeId', id));
    return r;
  },
  async getPersonnels(id) {
    const r = await client.get(routeList.personnels.replace(':routeId', id));
    return r;
  },
  async getRouteDetails(id) {
    const r = await client.get(routeList.routeDetails.replace(':routeId', id));
    return r;
  },
  async getActiveRoutes(id) {
    const r = await client.get(routeList.activeRoutes.replace(':routeId', id));
    return r;
  },
  async getDraftRoutes(id) {
    const r = await client.get(routeList.draftRoutes.replace(':routeId', id));
    return r;
  },
  async getRouteVersion(id, fetchActive = false) {
    const endpoint = fetchActive ? routeList.activeRoutes : routeList.draftRoutes;
    const r = await client.get(endpoint.replace(':routeId', id));
    return r;
  },
  async getServiceCompanies() {
    const r = await client.get(routeList.serviceCompanies);
    return r;
  },
  async getHakedisKalemleri() {
    const r = await client.get(routeList.hakedisKalemleri);
    return r;
  },
  async getHakedis(id) {
    const r = await client.get(routeList.hakedis.replace(':routeId', id));
    return r;
  },
  async addRotaKalemi(payload) {
    const r = await client.post(routeList.addRotaKalemi, payload);
    return r;
  },
  async getAccounting(id) {
    const r = await client.get(routeList.accounting.replace(':routeId', id));
    return r;
  },
  async getCardIssuance(routeId, fromDate, toDate) {
    const r = await client.get(
      routeList.cardIssuance.replace(':routeId', routeId).replace(':fromDate', fromDate).replace(':toDate', toDate),
    );
    return r;
  },
  async getJourney(routeId, fromDate, toDate) {
    const r = await client.get(
      routeList.journey.replace(':routeId', routeId).replace(':fromDate', fromDate).replace(':toDate', toDate),
    );
    return r;
  },
  async transferRoute(routeId, fromDate, toDate) {
    const r = await client.get(
      routeList.transferRoute.replace(':routeId', routeId).replace(':fromDate', fromDate).replace(':toDate', toDate),
    );
    return r;
  },
  async addRoute(payload) {
    const r = await client.post(routeList.addUpdate, payload);
    return r;
  },
  async getAccountings() {
    const r = await client.get(routeList.accountingList);
    return r;
  },
  async getVehicles(lightMode, serviceCompanyId) {
    const r = await client.get(vehicles.vehicles, { lightMode, serviceCompanyId });
    return r;
  },
  async getVehiclesPrm(serviceCompanyId) {
    const r = await client.get(vehicles.vehiclesPrm, { serviceCompanyId });
    return r;
  },
  async getDrivers(serviceCompanyId, vanpool) {
    // vanpool: true -> vanpool,
    // false -> shuttle,
    // none -> both
    const params = { serviceCompanyId };
    if (vanpool !== undefined) {
      params.vanpool = vanpool;
    }
    const r = await client.get(routeList.drivers, params);
    return r;
  },
  async transfer(payload) {
    // TODO
    const r = await client.post(routeList.transfer, payload);
    return r;
  },
  async deleteStation(stationId) {
    const r = await client.delete(routeList.deleteStation.replace(':stationId', stationId));
    return r;
  },
  async updateDraftRoutes(routeId, payload) {
    const r = await client.post(routeList.updateDraftRoutes.replace(':routeId', routeId), payload);
    return r;
  },
  async activateRoute(routeId, payload) {
    const r = await client.post(routeList.activateDraft.replace(':routeId', routeId), payload);
    return r;
  },
  async addUpdateStations(payload) {
    const r = await client.post(routeList.stations, payload);
    return r;
  },
  async addStation(payload) {
    const r = await client.post(routeList.addStation, payload);
    return r;
  },
  async createEditRoute(payload, id) {
    const r = await client.post(routeList.editRoutes.replace(':instanceId', id), payload);
    return r;
  },
  async updateEditRoutes(payload, id) {
    const r = await client.put(routeList.editRoutes.replace(':instanceId', id), payload);
    return r;
  },
  async getEditRoutes(id) {
    const r = await client.get(routeList.editRoutes.replace(':instanceId', id));
    return r;
  },
  async setEditRoutes(id, routeIds) {
    const r = await client.post(routeList.editRoutes.replace(':instanceId', id), { routeIds });
    return r;
  },
  async cancelEditRoutes(id) {
    const r = await client.post(routeList.cancelEditRoutes.replace(':instanceId', id));
    return r;
  },
  async saveAndActivate(payload, id) {
    const r = await client.post(routeList.saveAndActive.replace(':instanceId', id), payload);
    return r;
  },
  async getRouteData(instanceId, reservationDay = null) {
    const r = await client.get(routeList.routeData.replace(':instanceId', instanceId), { reservationDay });
    return r;
  },
  // async sendSelectedToOptimization(workgroupId, selected) {
  //   const r = await client.get(routeList.sendSelectedToOptimization, {
  //     workgroupV2Id: workgroupId,
  //     personnelIds: selected.join(','),
  //   });
  //   return r;
  // },
  async sendSelectedToOptimization(payload) {
    const r = await client.post(routeList.sendSelectedToOptimization, payload);
    return r;
  },
  async getApprovalList(routeId) {
    const r = await client.get(routeList.approval.replace(':versionedRouteId', routeId));
    return r;
  },
  async startApproval(routeId, payload) {
    const r = await client.post(routeList.startApproval.replace(':versionedRouteId', routeId), payload);
    return r;
  },
  async assignPersonnelDriver(routeId, payload) {
    const r = await client.post(routeList.assignPersonnelDriver.replace(':routeId', routeId), payload);
    return r;
  },
  async assignSecondaryDriver(routeId, payload) {
    const r = await client.post(routeList.assignSecondaryDriver.replace(':routeId', routeId), payload);
    return r;
  },
  async deleteSecondaryDriver(routeId, payload) {
    const r = await client.post(routeList.deleteSecondaryDriver.replace(':routeId', routeId), payload);
    return r;
  },
  async updateDrafts(workgroupId, payload) {
    const url = routeList.routeData.replace(':instanceId', workgroupId);
    const r = await client.put(url, payload);
    return r;
  },
  async activateDrafts(workgroupId, payload) {
    const url = routeList.updateActivate.replace(':instanceId', workgroupId);
    const r = await client.post(url, payload);
    return r;
  },
  async getRidersStatus(monitorDay) {
    const url = `${routeList.routesStatus}/riders`;
    const r = await client.get(url, { monitorDay });
    return r;
  },
  async getRoutesStatus(startDay, endDay, workingTypes, workgroupType) {
    const url = `${routeList.routesStatus}/routes`;
    const r = await client.get(url, {
      startDay,
      endDay,
      workingTypes,
      workgroupType,
    });
    return r;
  },
  async startOptimization(workgroupId) {
    const r = await client.get(routeList.startOptimization.replace(':instanceId', workgroupId));
    return r;
  },
  async updateRoutes(payload) {
    const r = await client.post(routeList.updateRoutes, payload);
    return r;
  },
  async updateRoutesRing(payload) {
    const r = await client.put(routeList.updateRoutesRing, payload);
    return r;
  },
  async getRouteDetail(routeInstanceId) {
    const url = `${routeList.routesStatus}/route/${routeInstanceId}`;
    const r = await client.get(url);
    return r;
  },
  async getVehiclePosition(routeInstanceId) {
    const url = `${routeList.routesStatus}/route/${routeInstanceId}/vehicle-position`;
    const r = await client.get(url);
    return r;
  },
  async updateStationStats(payload) {
    const r = await client.post(routeList.updateStationStats, { routeStations: payload });
    return r;
  },
  async getRiderStatus(fromDay, toDay, workingTypes, workgroupType, config = {}) {
    const r = await client.get(
      routeList.routeRiderStatus,
      {
        fromDay,
        toDay,
        workingTypes,
        workgroupType,
      },
      false,
      config,
    );
    return r;
  },
  async getVehicleHistory(routeInstanceId) {
    const url = `${routeList.routesStatus}/route/${routeInstanceId}/vehicle-history`;
    const r = await client.get(url);
    return r;
  },
  async getTransferInfo(id, date) {
    const url = routeList.routeDetails.replace(':routeId', id);
    const r = await client.get(`${url}/transfer-info?transferDay=${date}`);
    return r;
  },
  async getCardEvents(id, fromDate, toDate) {
    const url = routeList.cardEvents.replace(':routeId', id);
    const r = await client.get(`${url}`, { fromDate, toDate });
    return r;
  },
  async getTrackingData(workgroupType, today = false) {
    const url = today ? routeList.trackingDataDaily : routeList.trackingData;
    const r = await client.get(url, { workgroupType });
    return r;
  },
  async getTrackingDataByDay(workgroupType, day = undefined) {
    const url = routeList.trackingDataDaily;
    const r = await client.get(url, { workgroupType, day });
    return r;
  },
  async getTrackingVehiclePosition() {
    const r = await client.get(routeList.trackingVehiclePosition);
    return r;
  },
  async getTrackingAllVehiclePosition() {
    const r = await client.get(routeList.trackingAllVehiclePosition);
    return r;
  },
  async tripCancel(id) {
    const r = await client.post(routeList.tripCancel.replace(':routeInstanceId', id));
    return r;
  },
  async tripCancelMultiple(routeInstanceIds) {
    const r = await client.post(routeList.tripCancelMultiple, routeInstanceIds);
    return r;
  },

  async tripRevertCancel(id) {
    const r = await client.post(routeList.tripRevertCancel.replace(':routeInstanceId', id));
    return r;
  },
  async tripNotify(id, payload) {
    const r = await client.post(routeList.tripNotify.replace(':routeInstanceId', id), payload);
    return r;
  },
  async updateMultiHakedisStatus(payload) {
    const r = await client.post(routeList.updateMultiHakedisStatus, payload);
    return r;
  },
  async getHakedisMessage(id) {
    const r = await client.get(routeList.hakedisMessage.replace(':routeInstanceId', id));
    return r;
  },
  async getOriginalList() {
    const r = await client.get(routeList.originalList);
    return r;
  },
  async getTemporaryList() {
    const r = await client.get(routeList.temporaryList);
    return r;
  },
  async routeScheduleAdd(payload) {
    const r = await client.post(routeList.routeScheduleAdd, payload);
    return r;
  },
  async routeScheduleDelete(payload) {
    const r = await client.delete(routeList.routeScheduleDelete.replace(':id', payload));
    return r;
  },
  async routeScheduleHasOnTheWay(payload) {
    const r = await client.post(routeList.routeScheduleHasOnTheWay, payload);
    return r;
  },
  async routeScheduleHasConflict(payload) {
    const r = await client.post(routeList.routeScheduleHasConflict, payload);
    return r;
  },
  async scheduleChangeNotify(payload) {
    const r = await client.post(routeList.scheduleChangeNotify, payload);
    return r;
  },
  async createMissingInstances(payload) {
    const r = await client.post(routeList.createMissingInstances, payload);
    return r;
  },
  async getPlannedPersonnel(routeInstanceId) {
    const r = await client.get(routeList.plannedPersonnel.replace(':routeInstanceId', routeInstanceId));
    return r;
  },
  async getActualPersonnel(routeInstanceId) {
    const r = await client.get(routeList.actualPersonnel.replace(':routeInstanceId', routeInstanceId));
    return r;
  },
  async getRouteSearch(payload) {
    const r = await client.get(routeList.routeSearch, payload);
    return r;
  },
  async getPersonnelRouteSearch(payload) {
    const r = await client.get(routeList.personnelRouteSearch, payload);
    return r;
  },
  async reservationPorting(payload) {
    const r = await client.post(routeList.reservationPorting, payload);
    return r;
  },
  async reservationNotify(payload) {
    const r = await client.post(routeList.reservationNotify, payload);
    return r;
  },
  async getActualRouteSchedules(params) {
    const r = await client.get(routeList.actualRouteSchedules, params);
    return r;
  },
  async getOriginalRouteSchedules() {
    const r = await client.get(routeList.originalRouteSchedules);
    return r;
  },
  async getPlannedRouteSchedules() {
    const r = await client.get(routeList.plannedRouteSchedules);
    return r;
  },
  async getTemporaryRouteSchedules() {
    const r = await client.get(routeList.temporaryRouteSchedules);
    return r;
  },
  async getSimilarWorkgroups(instanceId) {
    const r = await client.get(routeList.similarWorkgroups.replace(':instanceId', instanceId));
    return r;
  },

  async getAllShuttleRoutes(params) {
    const r = await client.get(routeList.getAllShuttleRoutes, params);
    return r;
  },

  async checkCapacityReduction(payload) {
    const r = await client.post(routeList.capacityReductionCheck, payload);
    return r;
  },

  // updates driver-vehicle assignment on a route instance
  // payload: [{ routeInstanceId, driverId, vehicleId }]

  async updateDriverVehicleOnInstance(payload) {
    const r = await client.post(routeList.updateDriverVehicleOnInstance, payload);
    return r;
  },

  // ==================== BLOCK MANAGEMENT ENDPOINTS ====================
  // TODO: Update these endpoints when backend API is ready

  async getBlocks(serviceCompanyId) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.get(routeList.blocks, { serviceCompanyId });
    // return r;
    console.warn('getBlocks: Using placeholder - implement actual API endpoint', { serviceCompanyId });
    return Promise.resolve([]);
  },

  async createBlock(payload) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.post(routeList.createBlock, payload);
    // return r;
    console.warn('createBlock: Using placeholder - implement actual API endpoint', payload);
    return Promise.resolve({ id: Date.now(), ...payload });
  },

  /**
   * Update an existing block
   * @param {string} blockId - Block ID
   * @param {Object} payload - Updated block data { displayName }
   * @returns {Promise<Object>} Updated block
   */
  async updateBlock(blockId, payload) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.put(routeList.updateBlock.replace(':blockId', blockId), payload);
    // return r;

    // Placeholder implementation
    console.warn('updateBlock: Using placeholder - implement actual API endpoint', blockId, payload);
    return Promise.resolve({ id: blockId, ...payload });
  },

  /**
   * Delete a block
   * @param {string} blockId - Block ID
   * @returns {Promise<void>}
   */
  async deleteBlock(blockId) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.delete(routeList.deleteBlock.replace(':blockId', blockId));
    // return r;

    // Placeholder implementation
    console.warn('deleteBlock: Using placeholder - implement actual API endpoint', blockId);
    return Promise.resolve();
  },

  /**
   * Assign blocks to route trips
   * @param {Object} payload - Assignment data
   * @param {string} payload.routeId - Route ID
   * @param {Array} payload.assignments - Array of assignments
   * @returns {Promise<Object>} Assignment result
   */
  async assignBlocks(payload) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.post(routeList.assignBlocks, payload);
    // return r;

    // Placeholder implementation
    console.warn('assignBlocks: Using placeholder - implement actual API endpoint', payload);
    return Promise.resolve({ success: true, assignments: payload.assignments });
  },

  /**
   * Get block assignments for a route
   * @param {string} routeId - Route ID
   * @param {string} fromDate - Start date (YYYY-MM-DD)
   * @param {string} toDate - End date (YYYY-MM-DD)
   * @returns {Promise<Array>} List of block assignments
   */
  async getBlockAssignments(routeId, fromDate, toDate) {
    // TODO: Replace with actual endpoint when available
    // const r = await client.get(
    //   routeList.blockAssignments
    //     .replace(':routeId', routeId)
    //     .replace(':fromDate', fromDate)
    //     .replace(':toDate', toDate)
    // );
    // return r;

    // Placeholder implementation
    console.warn('getBlockAssignments: Using placeholder - implement actual API endpoint', routeId, fromDate, toDate);
    return Promise.resolve([]);
  },
};
